// extracted by mini-css-extract-plugin
export default {"headerDiv":"PageHeader_headerDiv__pxni-","color-add":"PageHeader_color-add__58Qca"};